export default __webpack_public_path__ + "static/media/access2.469d88ce.png";